<div
  class="pr-4 pl-4 pt-4 pb-4 border highlight"
  (click)="clickCard()">

  <div
    fxLayout="row"
    fxLayoutAlign="space-between center">
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      class="mt-1">
      @if (card.layer) {
        <div class="mr-2">
          @if (!card?.layer?.isCustomIcon) {
            <div
              class="typeIcon"
              [style]="'background-color:' + (card?.layer?.color || '#FFFFFF') + ';color: #FFFFFF;'"
              fxLayout="row"
              fxLayoutAlign="space-around center">
              <div
                class="material-icons"
                style="font-size: 16px">
                {{ card?.layer?.iconPath }}
              </div>
            </div>
          }
          @if (!!card?.layer?.isCustomIcon) {
            <div
              class="typeIcon"
              [style]="'background-color:' + (!card?.layer?.color ? '#FFFFFF' : card?.layer?.color)">
              <img
                [src]="card?.layer?.iconPath | safeUrl"
                class="customIcon" />
            </div>
          }
        </div>
      }
      <div>
        @if (typeName) {
          <span
            class="typeName">
            {{ typeName }}
          </span>
        }
        @if (categoryName) {
          <span
            class="typeName"
            [ngClass]="{ 'vertical': !!typeName }">
            {{ categoryName }}
          </span>
        }
      </div>
    </div>
    @if (!!location) {
      <div
        class="mt-1"
        >
        <div
          class="zoomToDocument"
          (click)="onZoomToDocument()">
          <i
            class="icon icon-zoom-to_location"
          style="font-size: 1.5rem"></i>
        </div>
      </div>
    }
  </div>

  <div
    fxLayout="row"
    fxLayoutAlign="start start"
    class="mt-1">
    @if (!!imageUrl || !!encodedImage) {
      <div class="mb-2 mr-2">
        <img
          class="image-stream"
          src="{{ imageUrl }}"
          alt="data:image/jpeg;base64,{{ encodedImage }}" />
      </div>
    }
    <div>
      <div>
        <span class="summary">{{ summary | stripHtml }}</span>
      </div>

      @if (severityText) {
        <div
          fxLayout="row"
          fxLayoutAlign="start start"
          class="mt-3">
          <span class="severity">{{ severityText }}</span>
        </div>
      }
    </div>
  </div>

  <div
    fxLayout="row"
    fxLayoutAlign="space-between"
    class="posted mt-2">
    <div>
      <span>{{ postedDateTime }}</span>
    </div>
    <div>{{ postedElapsedTime }}</div>
  </div>

  @if (!!card?.workflowName) {
    <div
      class="mt-2"
      style="width: calc(100% - 2rem)"
      fxLayout="row"
      fxLayoutAlign="start center">
      <div
        class="workflow-color"
        [ngStyle]="{ 'background-color': card?.workflowColor }">
        &nbsp;
      </div>
      <div class="workflow-status">{{ card?.workflowName }}</div>
    </div>
  }

  @if (customFieldsSet) {
    <div>
      <div class="mt-3">
        <div
          topoDynamicForm
          [formView]="truncatedView"
          [schema]="card?.dataset?.schema"
          [document]="card?.document"
          [isEdit]="false"
          [controlCollection]="documentControls"
          [dataset]="card?.dataset"
        [layerUId]="card?.layer?.uId ?? guidEmpty"></div>
      </div>
    </div>
  }
</div>
